import type { MediaItem } from '@/shared/components/PromptRenderer';

/**
 * Normalise mediaRefsJson from session snapshots.
 * New format: array of MediaItem objects.
 * Legacy format: single object with { url, type, filename }.
 * Returns null if no valid media is present.
 */
export function normaliseMediaRefs(raw: unknown): MediaItem[] | null {
  if (Array.isArray(raw)) {
    return raw as MediaItem[];
  }
  if (raw && typeof raw === 'object' && 'url' in (raw as Record<string, unknown>)) {
    return [raw as MediaItem];
  }
  return null;
}
